<template>
  <div class="home">
    <head-com></head-com>
    <div class="main">
      <div class="cont bs">
        <el-tabs class="tabs" v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="我的练习" name="first">
            <ul class="list cl">
              <li class="cl" v-for="(item, i) in 10" :key="i">
                <div class="wrap bs">
                  <div class="top">建设工程质量见证取样检测见证取样检测</div>
                  <div class="center">
                    <span>在线练习</span>
                    <span>总题数: 50</span>
                  </div>
                  <div class="bot">
                    <el-button type="primary" plain size="small" @click="start">开始做题</el-button>
                  </div>
                </div>
              </li>
            </ul>
            <el-pagination
              background
              :page-size="pageSize"
              :total="totalCount"
              :page-count="totalPage"
              :current-page="currentPage"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              @prev-click="prevPage"
              @next-click="nextPage"
              layout="total, sizes,prev, pager, next,  jumper"
            ></el-pagination>
          </el-tab-pane>
          <el-tab-pane label="练习记录" name="second">
            <ul class="theme">
              <li class="flex" v-for="(item, i) in 8" :key="i">
                <div class="theme-l">
                  <h3 class="title">【模拟考试】安管人员考试考核A</h3>
                  <div class="line">
                    <span>开始时间：2019-01-26 12：30:06</span>
                    <span>交卷时间：2019-01-26 14：30:20</span>
                  </div>
                  <div class="line">
                    <span>得分：58分</span>
                    <span>满分：60分</span>
                  </div>
                </div>
                <div class="theme-r">
                  <el-button type="primary" size="small" @click="checkResult">查看结果</el-button>
                  <el-button type="primary" plain size="small" @click="again">再做一次</el-button>
                </div>
              </li>
            </ul>
            <el-pagination
              background
              :page-size="pageSize"
              :total="totalCount"
              :page-count="totalPage"
              :current-page="currentPage"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              @prev-click="prevPage"
              @next-click="nextPage"
              layout="total, sizes,prev, pager, next,  jumper"
            ></el-pagination>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <footer-com></footer-com>
  </div>
</template>

<script>
import HeadCom from "@/components/Header.vue";
import FooterCom from "@/components/Footer.vue";
import http from "../api/module";

export default {
  name: "online",
  data() {
    return {
      activeName: "first",
      pageSize: 10, // 每页显示个数
      totalPage: 10, // 总页数
      totalCount: 20, // 总条目数
      currentPage: 1 // 当前页
    };
  },
  components: {
    HeadCom,
    FooterCom
  },
  mounted() {
    this.getDataList();
  },
  methods: {
    getDataList() {
      http
        .getExerciseList({
          tokenId: sessionStorage.getItem("token")
        })
        .then(data => {})
        .catch(error => {});
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    start() {
      this.$router.push({
        path: "/exercise"
      });
    },
    checkResult() {
      this.$router.push({
        path: "/viewResult"
      });
    },
    again() {
      this.$router.push({
        path: "/exercise"
      });
    },
    // 每页数
    handleSizeChange(val) {
      console.log(val);
    },
    // 当前页
    handleCurrentChange(val) {
      console.log(val);
    },
    // 上一页
    prevPage() {
      // console.log('上一页');
    },
    // 下一页
    nextPage() {
      // console.log('下一页');
    }
  }
};
</script>
<style lang="less" scoped>

.main {
  .cont {
    margin: 30px 0;
    background: #ffffff;
    padding: 20px 20px 0 20px;
    border-radius: 6px;
  }
  /deep/.el-pagination{
    text-align: center !important;
  }
}
.list {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  &:after {
    content: "";
    flex: auto;
  }
  li {
    width: 23%;
    height: 200px;
    margin-right: 30px;
    margin-top: 30px;
    position: relative;
    &:nth-child(4n) {
      margin-right: 0;
    }
    .wrap {
      width: 100%;
      border-radius: 6px;
      position: absolute;
      left: 1px;
      top: 0;
      transition: 0.3s;
      &:hover {
        box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);
        top: -10px;
      }
    }
  }
}
.top {
  width: 100%;
  padding: 0 14px;
  background: #409eff;
  line-height: 40px;
  border-radius: 6px 6px 0 0;
  color: #ffffff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.center {
  padding: 30px 12px;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #ddd;
  span {
    padding: 6px 20px;
    border: 1px solid #ddd;
    border-radius: 30px;
  }
}
.bot {
  padding: 12px;
}
.theme {
  li {
    padding: 20px;
    border-bottom: 1px solid #ddd;
    .title {
      line-height: 40px;
    }
    .line {
      line-height: 30px;
      font-size: 14px;
      color: #999999;
    }
  }
}
</style>
